"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styles_1 = require("@mui/material/styles");
function createGradient(color1, color2) {
    return `linear-gradient(135deg, ${color1}, ${color2})`;
}
// SETUP COLORS
const PRIMARY = {
    lighter: '#E1E3EA',
    light: '#B4BCCC',
    main: '#1D3A6C',
    dark: '#18284D',
    darker: '#0F1834',
};
const SECONDARY = {
    lighter: '#FFF8E0',
    light: '#FFDF7C',
    main: '#FFC905',
    dark: '#FFB100',
    darker: '#FF8C00',
};
const INFO = {
    lighter: '#DDF3FD',
    light: '#7DD3F6',
    main: '#1EB2F0',
    dark: '#0B74A0',
    darker: '#042F40',
};
const SUCCESS = {
    lighter: '#E2F7E5',
    light: '#92E29C',
    main: '#42CC54',
    dark: '#248631',
    darker: '#0F3614',
};
const WARNING = {
    lighter: '#FDF1DD',
    light: '#F6C97D',
    main: '#F0A21E',
    dark: '#A0680B',
    darker: '#402A04',
};
const ERROR = {
    lighter: '#FBE2DE',
    light: '#EF9284',
    main: '#E4422A',
    dark: '#972413',
    darker: '#3D0F08',
};
const GREY = {
    0: '#FFFFFF',
    100: '#f5f5f3',
    200: '#f1f1ef',
    300: '#dfdfdd',
    400: '#cacac8',
    500: '#9e9d9b',
    600: '#747472',
    700: '#525251',
    800: '#2e2e2d',
    900: '#20201f',
    500_8: (0, styles_1.alpha)('#9e9d9b', 0.08),
    500_12: (0, styles_1.alpha)('#9e9d9b', 0.12),
    500_16: (0, styles_1.alpha)('#9e9d9b', 0.16),
    500_24: (0, styles_1.alpha)('#9e9d9b', 0.24),
    500_32: (0, styles_1.alpha)('#9e9d9b', 0.32),
    500_48: (0, styles_1.alpha)('#9e9d9b', 0.48),
    500_56: (0, styles_1.alpha)('#9e9d9b', 0.56),
    500_80: (0, styles_1.alpha)('#9e9d9b', 0.8),
};
const GRADIENTS = {
    primary: createGradient(PRIMARY.main, '#79FAC5'),
    secondary: createGradient(SECONDARY.main, '#FFC1B2'),
    info: createGradient(INFO.light, INFO.dark),
    success: createGradient(SUCCESS.light, SUCCESS.dark),
    warning: createGradient(WARNING.light, WARNING.dark),
    error: createGradient(ERROR.light, ERROR.dark),
};
const CHART_COLORS = {
    violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
    blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
    green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
    yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
    red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
};
const COMMON = {
    common: { black: '#000', white: '#fff' },
    primary: { ...PRIMARY, contrastText: '#fff' },
    secondary: { ...SECONDARY, contrastText: GREY[800] },
    info: { ...INFO, contrastText: '#fff' },
    success: { ...SUCCESS, contrastText: GREY[800] },
    warning: { ...WARNING, contrastText: GREY[800] },
    error: { ...ERROR, contrastText: '#fff' },
    grey: GREY,
    gradients: GRADIENTS,
    chart: CHART_COLORS,
    divider: GREY[500_24],
    action: {
        hover: GREY[500_8],
        selected: GREY[500_16],
        disabled: GREY[500_80],
        disabledBackground: GREY[500_24],
        focus: GREY[500_24],
        hoverOpacity: 0.08,
        disabledOpacity: 0.48,
    },
};
const palette = {
    light: {
        ...COMMON,
        mode: 'light',
        text: { primary: GREY[800], secondary: GREY[600], disabled: GREY[500] },
        background: { paper: '#fff', default: GREY[200], neutral: GREY[100], dark: '#161B24' },
        action: { active: GREY[600], ...COMMON.action },
    },
    dark: {
        ...COMMON,
        mode: 'dark',
        text: { primary: '#fff', secondary: GREY[500], disabled: GREY[600] },
        background: { paper: '#212936', default: '#191D2A', neutral: GREY[500_16], dark: '#161B24' },
        action: { active: GREY[500], ...COMMON.action },
    },
};
exports.default = palette;
